"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trommelJson = void 0;
const TrommelModel_1 = require("./TrommelModel");
const VerpackungModel_1 = require("./VerpackungModel");
exports.trommelJson = {
    EntityId: '1508954445089_947461',
    Id: 1805874262,
    ArtNr: { DE: 'MAT0178542' },
    ArtNrExists: true,
    ArtNrGenerated: 'MAT0178542',
    Bezeichnung: { 'de-DE': 'Trommel', 'en-GB': 'Drum', 'en-US': 'Drum' },
    Preis: { Countries: { DE: { EUR: 403.95 } } },
    Typ: VerpackungModel_1.VerpackungType.trommel,
    Verpackungsmittel: 'Trommel',
    Kerndurchmesser: { Unit: 'mm', Value: 455 },
    Innenbreite: { Unit: 'mm', Value: 700 },
    Flanschdurchmesser: { Unit: 'mm', Value: 1800 },
    Flanschstaerke: { Unit: 'mm', Value: 24 },
    TrommelbelastungMax: { Unit: 'kg', Value: 500 },
    Trommelkern: TrommelModel_1.Trommelkern.festpunkt,
    Waermebehandelt: true,
};
//# sourceMappingURL=trommelJson.js.map